<template>
  <modal v-if="show" class="modal-payment-details" @close="closeModal">
    <h3 slot="header">Infos paiement</h3>
    <template slot="body">
      <div class="text-center" v-if="isLoading">
        <i class="loading material-icons">cached</i>
      </div>
      <template v-else>
        <div v-if="payment && payment.done">
          <div class="flex">
            <label>{{$resx('TransfertDateText')}}</label>
            <span>{{payment.formatedDate}}</span>
          </div>
          <div class="flex">
            <label>{{$resx('TransfertAmountText')}}</label>
            <span>{{payment.formatedAmount}}</span>
          </div>
          <div class="flex">
            <label>{{$resx('IbanNumberText')}}</label>
            <span>{{payment.iban}}</span>
          </div>
        </div>
        <div v-else>
          <p v-html="$resx('TransfertWaitingText')"></p>
        </div>
        <br />
        <button class="btn btn-secondary" type="button" @click="closeModal">{{$resx('CloseText')}}</button>
      </template>
    </template>
  </modal>
</template>
<script>
import modal from '../modal.vue'
import bookingServices from '../../services/bookingServices'
import BookingPayment from '../../models/booking/bookingPayment'

export default {
  props: {
    show: Boolean,
    id: Number
  },
  data () {
    return {
      isLoading: false,
      payment: null
    }
  },
  watch: {
    id: function () {
      if (this.id !== null) {
        this.loadPaymentDetails()
      }
    }
  },
  computed: {
    // camping actuellement sélectionné
    currentCampingId () {
      return this.$store.getters['partner/currentCampingId']
    }
  },
  methods: {
    // fermeture de la popup
    closeModal () {
      this.$emit('onPaymentDetailsClose')
    },

    // charger les détails du paiement
    async loadPaymentDetails () {
      try {
        this.isLoading = true
        var data = await bookingServices.loadBookingPayment(this.id)
        this.payment = new BookingPayment(data)
      } catch (error) {
        this.$store.commit('app/showSnack', { type: 'error', message: error.response.data.message })
        this.payment = null
      } finally {
        this.isLoading = false
      }
    }
  },
  components:
  {
    modal: modal
  }
}
</script>
<style lang="less">
  .modal-payment-details {
    .modal-container
    {
      max-width: 40em;
    }
  }
</style>
<style lang="less" scoped>
  @import '../../assets/variables.less';

  .loading{
    color:white!important;
  }

  h3 {
    font-family: 'Playfair Display';
    font-weight: @fontBold;
    font-size: 3em !important;
    color: white !important;
    margin-bottom: 1em !important;
  }

  p, label, span{
    color:white;
    font-size:1.25em;
  }

  label {
    font-weight: @fontBold;
  }

  .flex{
    margin:.5em 0;
  }
</style>
